import IconLinkButton from "components/common/controls/IconLinkButton";
import addIconSvg from "static/images/add-icon.svg";

interface Props {
  text?: string;
  responsive?: boolean;
  onClick: () => void;
}

export default function NewButton({ text, responsive, onClick }: Props) {
  return (
    <IconLinkButton
      responsive={responsive}
      text={text || "New"}
      icon={addIconSvg}
      onClick={onClick}
    />
  );
}
